export enum RepaymentMethod {
    DirectDebit = 0,
    Paper = 1
}
